import React, { Component } from 'react';
import autobind from 'react-autobind'
import SubscriptionBox from './SubscriptionBox'
// import Switch from 'react-toggle-switch'
import Alert from './../Errors/Alert'

export default class SubscriptionBoxList extends Component {

    constructor(props) {
        super(props)
        autobind(this)

        this.state = {
            switch: false
        }
    }

    toggle() {
        this.setState({
            switch: !this.state.switch
        })
    }

    render() {
        const { subscriptions: propSubs, register, errorMessage, collapsed } = this.props
        let subscriptions = propSubs.map((subscription) => {
            return {
                id: subscription._id,
                markup: (<div key={'subscription_' + subscription._id} className="col" style={{ paddingLeft: 6, paddingRight: 6 }}>
                    <SubscriptionBox
                        active={this.props.activeSubscriptionId === subscription._id}
                        activePlan={this.props.currentSubscriptionId === subscription._id}
                        type="free"
                        isBestChoice={false}
                        register={register}
                        subscription={subscription}
                        onConfirmUpgrade={() => { this.props.onConfirmUpgrade(subscription._id) }}
                        removeSelection={() => { this.props.removeSelection(subscription._id) }}
                        onChoosePlanClick={() => { this.props.onChoosePlanClick(subscription._id) }} />
                </div>)
            }
        })

        const subscriptionsMarkup = subscriptions.map((subscription) => {
            return subscription.markup;
        })

        return (
            <div>
                <div className="panel panel--rounded panel-default mb-5">
                    {this.props.first ? <div className="panel-heading panel-heading--lg panel-heading-divider">Payment plans</div> : ''}
                    <div className="panel-body">
                        {errorMessage ? (<div className="form-group row d-flex justify-content-center">
                            <div className="col-sm-6">
                                <Alert message={errorMessage} />
                            </div>
                        </div>) : null}
                        <div className={'d-none ' + (this.props.collapsed ? ' mb-0' : ' mb-3')}>
                            <div className="d-flex align-items-center">
                                {this.props.register ? (<label className="custom-control custom-checkbox mb-0">
                                    <input type="checkbox" className="custom-control-input" checked={!this.props.collapsed} onChange={() => { this.props.toggleCollapse(this.props.id) }} /><span className="custom-control-indicator"></span>
                                </label>) : ''}
                            </div>
                        </div>
                        {!collapsed ? (<div className="row pricing-tables">
                            {subscriptionsMarkup}
                        </div>) : null}
                    </div>
                </div>
                {this.props.showDisclaimer ? (<p className="mt-2 mb-5 text-center disclaimer-text">* Additional traffic costs will be applied after meeting the assigned traffic load for your package. For package prices, taxes not included.</p>) : ''}
            </div>
        )

    }

}



// WEBPACK FOOTER //
// ./src/components/Subscription/SubscriptionBoxList.js